import React from 'react';
import { PageHeader } from '../components/SectionHeader';
import { faqData } from '../data/nflData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { HelpCircle, MessageCircle } from 'lucide-react';

const FAQ = () => {
  return (
    <div className="min-h-screen" data-testid="faq-page">
      <PageHeader 
        title="Preguntas Frecuentes"
        subtitle="Respuestas a las dudas más comunes sobre la NFL"
        backgroundImage="https://images.unsplash.com/photo-1565789426992-9c335aa0a62c?auto=format&fit=crop&w=2000&q=80"
      />
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Intro */}
        <div className="flex items-start gap-4 mb-12 p-6 bg-slate-800/50 rounded-xl border border-slate-700">
          <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
            <HelpCircle className="w-6 h-6 text-emerald-400" />
          </div>
          <div>
            <h2 
              className="text-xl font-bold text-white mb-2"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              ¿Tienes una pregunta?
            </h2>
            <p className="text-slate-400">
              Aquí encontrarás respuestas a las preguntas más frecuentes de nuevos aficionados. 
              Si no encuentras lo que buscas, explora las otras secciones de la guía.
            </p>
          </div>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-slate-800 rounded-xl overflow-hidden bg-slate-900/50 data-[state=open]:border-emerald-800"
            >
              <AccordionTrigger 
                className="px-6 py-5 text-left hover:no-underline hover:bg-slate-800/50 transition-colors [&[data-state=open]]:bg-slate-800/30"
                data-testid={`faq-trigger-${index}`}
              >
                <span 
                  className="text-lg font-semibold text-white pr-4"
                  style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
                >
                  {item.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 text-slate-400 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional help */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 rounded-full">
            <MessageCircle className="w-5 h-5 text-emerald-400" />
            <span className="text-slate-300">
              ¿Más dudas? Explora el <a href="/glosario" className="text-emerald-400 hover:underline">Glosario</a> o 
              las secciones de <a href="/reglas" className="text-emerald-400 hover:underline">Reglas</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
